var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28029 0.300799C9.68136 -0.100266 10.3128 -0.100266 10.7138 0.300799C11.1013 0.688316 11.1013 1.33327 10.7138 1.71989L3.44497 8.98875H27.4312C27.9904 8.98875 28.4492 9.43318 28.4492 9.99232C28.4492 10.5515 27.9904 11.0103 27.4312 11.0103H3.44497L10.7138 18.2657C11.1013 18.6667 11.1013 19.3126 10.7138 19.6992C10.3128 20.1003 9.68136 20.1003 9.28029 19.6992L0.290637 10.7095C-0.0968791 10.322 -0.0968791 9.67707 0.290637 9.29046L9.28029 0.300799Z",
    fill: "#0D0C22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTr);
export default __webpack_public_path__ + "static/media/arrow-tr.b0c23e9f2ce33c70ee343bc790934876.svg";
export { ForwardRef as ReactComponent };